@if (totalItems() > 0) {
  <nav class="ui-pagination" aria-label="Pagination">
    <button
      type="button"
      class="ui-pagination__button"
      [disabled]="!hasPrevious()"
      (click)="goTo(page() - 1)"
      aria-label="Page précédente"
    >
      <ui-icon name="chevron-left" size="sm" />
    </button>

    @for (p of pages(); track p) {
      <button
        type="button"
        class="ui-pagination__button"
        [class.ui-pagination__button--active]="p === page()"
        [attr.aria-current]="p === page() ? 'page' : null"
        (click)="goTo(p)"
      >
        {{ p }}
      </button>
    }

    <button
      type="button"
      class="ui-pagination__button"
      [disabled]="!hasNext()"
      (click)="goTo(page() + 1)"
      aria-label="Page suivante"
    >
      <ui-icon name="chevron-right" size="sm" />
    </button>

    <span class="ui-pagination__range">{{ rangeLabel() }}</span>
  </nav>
}
